export const TOGGLE_STYLE_GUIDE_MODAL = 'TOGGLE_STYLE_GUIDE_MODAL';

export function toggleModal() {
  return { type: TOGGLE_STYLE_GUIDE_MODAL };
}
